/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetCustomerCustomerIdSurveysParams,
  GetSurveyCatalogParams,
  GetSurveyReviewQueueParams,
  GetSurveyTemplatesParams,
  PostSurveyAssignmentIdAnswerKeyPhotoBody,
  TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest,
  TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest,
  TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest,
  TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest,
  TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest,
  TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest,
  TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest,
  TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest,
  TrainWithMeModulesSurveysDtosResponsesCheckInAssignmentResultResponse,
  TrainWithMeModulesSurveysDtosResponsesCustomerSurveysResponse,
  TrainWithMeModulesSurveysDtosResponsesIntakeStatusResponse,
  TrainWithMeModulesSurveysDtosResponsesPendingSurveysResponse,
  TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse,
  TrainWithMeModulesSurveysDtosResponsesSurveyCatalogResponse,
  TrainWithMeModulesSurveysDtosResponsesSurveyPhotoAnswerResponse,
  TrainWithMeModulesSurveysDtosResponsesSurveyReviewQueueResponse,
  TrainWithMeModulesSurveysDtosResponsesSurveyTemplateListResponse,
  TrainWithMeModulesSurveysDtosResponsesSurveyTemplateResponse,
  TrainWithMeModulesSurveysDtosResponsesTrainerQuestionListResponse,
  TrainWithMeModulesSurveysDtosResponsesTrainerQuestionResponse,
  TrainWithMeModulesSurveysDtosSurveyPhotoPose
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCustomerCustomerIdSurveys = (
    customerId: number,
    params?: GetCustomerCustomerIdSurveysParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesCustomerSurveysResponse>(
      {url: `/customer/${customerId}/surveys`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerCustomerIdSurveysQueryKey = (customerId: number,
    params?: GetCustomerCustomerIdSurveysParams,) => {
    return [
    `/customer/${customerId}/surveys`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerCustomerIdSurveysQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError = ErrorType<unknown>>(customerId: number,
    params?: GetCustomerCustomerIdSurveysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerCustomerIdSurveysQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>> = ({ signal }) => getCustomerCustomerIdSurveys(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerCustomerIdSurveysQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>>
export type GetCustomerCustomerIdSurveysQueryError = ErrorType<unknown>


export function useGetCustomerCustomerIdSurveys<TData = Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError = ErrorType<unknown>>(
 customerId: number,
    params: undefined |  GetCustomerCustomerIdSurveysParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerCustomerIdSurveys<TData = Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetCustomerCustomerIdSurveysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerCustomerIdSurveys<TData = Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetCustomerCustomerIdSurveysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerCustomerIdSurveys<TData = Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetCustomerCustomerIdSurveysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerCustomerIdSurveys>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerCustomerIdSurveysQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postSurveyAssignment = (
    trainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse>(
      {url: `/survey/assignment`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest, signal
    },
      options);
    }




export const getPostSurveyAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignment>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignment>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest>}, TContext> => {

const mutationKey = ['postSurveyAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyAssignment>>, {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postSurveyAssignment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyAssignment>>>
    export type PostSurveyAssignmentMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest> | undefined
    export type PostSurveyAssignmentMutationError = ErrorType<unknown>

    export const usePostSurveyAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignment>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyAssignment>>,
        TError,
        {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostSurveyAssignmentRequest>},
        TContext
      > => {
      return useMutation(getPostSurveyAssignmentMutationOptions(options), queryClient);
    }
    export const postSurveyAssignmentSelf = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse>(
      {url: `/survey/assignment/self`, method: 'POST', signal
    },
      options);
    }




export const getPostSurveyAssignmentSelfMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentSelf>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentSelf>>, TError,void, TContext> => {

const mutationKey = ['postSurveyAssignmentSelf'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyAssignmentSelf>>, void> = () => {


          return  postSurveyAssignmentSelf(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyAssignmentSelfMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyAssignmentSelf>>>

    export type PostSurveyAssignmentSelfMutationError = ErrorType<unknown>

    export const usePostSurveyAssignmentSelf = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentSelf>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyAssignmentSelf>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostSurveyAssignmentSelfMutationOptions(options), queryClient);
    }
    export const getSurveyAssignmentId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse>(
      {url: `/survey/assignment/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyAssignmentIdQueryKey = (id: number,) => {
    return [
    `/survey/assignment/${id}`
    ] as const;
    }


export const getGetSurveyAssignmentIdQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyAssignmentIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyAssignmentId>>> = ({ signal }) => getSurveyAssignmentId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyAssignmentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyAssignmentId>>>
export type GetSurveyAssignmentIdQueryError = ErrorType<unknown>


export function useGetSurveyAssignmentId<TData = Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyAssignmentId>>,
          TError,
          Awaited<ReturnType<typeof getSurveyAssignmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyAssignmentId<TData = Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyAssignmentId>>,
          TError,
          Awaited<ReturnType<typeof getSurveyAssignmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyAssignmentId<TData = Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyAssignmentId<TData = Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyAssignmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyAssignmentIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postSurveyAssignmentIdAnswerKeyPhoto = (
    id: number,
    key: string,
    postSurveyAssignmentIdAnswerKeyPhotoBody?: BodyType<PostSurveyAssignmentIdAnswerKeyPhotoBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postSurveyAssignmentIdAnswerKeyPhotoBody?.File !== undefined) {
 formData.append(`File`, postSurveyAssignmentIdAnswerKeyPhotoBody.File);
 }
if(postSurveyAssignmentIdAnswerKeyPhotoBody?.Pose !== undefined) {
 formData.append(`Pose`, postSurveyAssignmentIdAnswerKeyPhotoBody.Pose);
 }

      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyPhotoAnswerResponse>(
      {url: `/survey/assignment/${id}/answer/${key}/photo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostSurveyAssignmentIdAnswerKeyPhotoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdAnswerKeyPhoto>>, TError,{id: number;key: string;data?: BodyType<PostSurveyAssignmentIdAnswerKeyPhotoBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdAnswerKeyPhoto>>, TError,{id: number;key: string;data?: BodyType<PostSurveyAssignmentIdAnswerKeyPhotoBody>}, TContext> => {

const mutationKey = ['postSurveyAssignmentIdAnswerKeyPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyAssignmentIdAnswerKeyPhoto>>, {id: number;key: string;data?: BodyType<PostSurveyAssignmentIdAnswerKeyPhotoBody>}> = (props) => {
          const {id,key,data} = props ?? {};

          return  postSurveyAssignmentIdAnswerKeyPhoto(id,key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyAssignmentIdAnswerKeyPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyAssignmentIdAnswerKeyPhoto>>>
    export type PostSurveyAssignmentIdAnswerKeyPhotoMutationBody = BodyType<PostSurveyAssignmentIdAnswerKeyPhotoBody> | undefined
    export type PostSurveyAssignmentIdAnswerKeyPhotoMutationError = ErrorType<unknown>

    export const usePostSurveyAssignmentIdAnswerKeyPhoto = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdAnswerKeyPhoto>>, TError,{id: number;key: string;data?: BodyType<PostSurveyAssignmentIdAnswerKeyPhotoBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyAssignmentIdAnswerKeyPhoto>>,
        TError,
        {id: number;key: string;data?: BodyType<PostSurveyAssignmentIdAnswerKeyPhotoBody>},
        TContext
      > => {
      return useMutation(getPostSurveyAssignmentIdAnswerKeyPhotoMutationOptions(options), queryClient);
    }
    export const deleteSurveyAssignmentIdAnswerKeyPhotoPose = (
    id: number,
    key: string,
    pose: TrainWithMeModulesSurveysDtosSurveyPhotoPose,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/survey/assignment/${id}/answer/${key}/photo/${pose}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSurveyAssignmentIdAnswerKeyPhotoPoseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyAssignmentIdAnswerKeyPhotoPose>>, TError,{id: number;key: string;pose: TrainWithMeModulesSurveysDtosSurveyPhotoPose}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyAssignmentIdAnswerKeyPhotoPose>>, TError,{id: number;key: string;pose: TrainWithMeModulesSurveysDtosSurveyPhotoPose}, TContext> => {

const mutationKey = ['deleteSurveyAssignmentIdAnswerKeyPhotoPose'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSurveyAssignmentIdAnswerKeyPhotoPose>>, {id: number;key: string;pose: TrainWithMeModulesSurveysDtosSurveyPhotoPose}> = (props) => {
          const {id,key,pose} = props ?? {};

          return  deleteSurveyAssignmentIdAnswerKeyPhotoPose(id,key,pose,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSurveyAssignmentIdAnswerKeyPhotoPoseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSurveyAssignmentIdAnswerKeyPhotoPose>>>

    export type DeleteSurveyAssignmentIdAnswerKeyPhotoPoseMutationError = ErrorType<unknown>

    export const useDeleteSurveyAssignmentIdAnswerKeyPhotoPose = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyAssignmentIdAnswerKeyPhotoPose>>, TError,{id: number;key: string;pose: TrainWithMeModulesSurveysDtosSurveyPhotoPose}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSurveyAssignmentIdAnswerKeyPhotoPose>>,
        TError,
        {id: number;key: string;pose: TrainWithMeModulesSurveysDtosSurveyPhotoPose},
        TContext
      > => {
      return useMutation(getDeleteSurveyAssignmentIdAnswerKeyPhotoPoseMutationOptions(options), queryClient);
    }
    export const postSurveyAssignmentIdMarkReviewed = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/survey/assignment/${id}/mark-reviewed`, method: 'POST', signal
    },
      options);
    }




export const getPostSurveyAssignmentIdMarkReviewedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdMarkReviewed>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdMarkReviewed>>, TError,{id: number}, TContext> => {

const mutationKey = ['postSurveyAssignmentIdMarkReviewed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyAssignmentIdMarkReviewed>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postSurveyAssignmentIdMarkReviewed(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyAssignmentIdMarkReviewedMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyAssignmentIdMarkReviewed>>>

    export type PostSurveyAssignmentIdMarkReviewedMutationError = ErrorType<unknown>

    export const usePostSurveyAssignmentIdMarkReviewed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdMarkReviewed>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyAssignmentIdMarkReviewed>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostSurveyAssignmentIdMarkReviewedMutationOptions(options), queryClient);
    }
    export const patchSurveyAssignmentIdProgress = (
    id: number,
    trainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse>(
      {url: `/survey/assignment/${id}/progress`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest, signal
    },
      options);
    }




export const getPatchSurveyAssignmentIdProgressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyAssignmentIdProgress>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSurveyAssignmentIdProgress>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}, TContext> => {

const mutationKey = ['patchSurveyAssignmentIdProgress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSurveyAssignmentIdProgress>>, {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSurveyAssignmentIdProgress(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchSurveyAssignmentIdProgressMutationResult = NonNullable<Awaited<ReturnType<typeof patchSurveyAssignmentIdProgress>>>
    export type PatchSurveyAssignmentIdProgressMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest> | undefined
    export type PatchSurveyAssignmentIdProgressMutationError = ErrorType<unknown>

    export const usePatchSurveyAssignmentIdProgress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyAssignmentIdProgress>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSurveyAssignmentIdProgress>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>},
        TContext
      > => {
      return useMutation(getPatchSurveyAssignmentIdProgressMutationOptions(options), queryClient);
    }
    export const postSurveyAssignmentIdSubmit = (
    id: number,
    trainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse>(
      {url: `/survey/assignment/${id}/submit`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest, signal
    },
      options);
    }




export const getPostSurveyAssignmentIdSubmitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdSubmit>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdSubmit>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}, TContext> => {

const mutationKey = ['postSurveyAssignmentIdSubmit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyAssignmentIdSubmit>>, {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  postSurveyAssignmentIdSubmit(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyAssignmentIdSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyAssignmentIdSubmit>>>
    export type PostSurveyAssignmentIdSubmitMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest> | undefined
    export type PostSurveyAssignmentIdSubmitMutationError = ErrorType<unknown>

    export const usePostSurveyAssignmentIdSubmit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyAssignmentIdSubmit>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyAssignmentIdSubmit>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsSaveSurveyProgressRequest>},
        TContext
      > => {
      return useMutation(getPostSurveyAssignmentIdSubmitMutationOptions(options), queryClient);
    }
    export const getSurveyCatalog = (
    params?: GetSurveyCatalogParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyCatalogResponse>(
      {url: `/survey/catalog`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSurveyCatalogQueryKey = (params?: GetSurveyCatalogParams,) => {
    return [
    `/survey/catalog`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSurveyCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyCatalog>>, TError = ErrorType<unknown>>(params?: GetSurveyCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyCatalogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyCatalog>>> = ({ signal }) => getSurveyCatalog(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyCatalog>>>
export type GetSurveyCatalogQueryError = ErrorType<unknown>


export function useGetSurveyCatalog<TData = Awaited<ReturnType<typeof getSurveyCatalog>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSurveyCatalogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyCatalog>>,
          TError,
          Awaited<ReturnType<typeof getSurveyCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyCatalog<TData = Awaited<ReturnType<typeof getSurveyCatalog>>, TError = ErrorType<unknown>>(
 params?: GetSurveyCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyCatalog>>,
          TError,
          Awaited<ReturnType<typeof getSurveyCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyCatalog<TData = Awaited<ReturnType<typeof getSurveyCatalog>>, TError = ErrorType<unknown>>(
 params?: GetSurveyCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyCatalog<TData = Awaited<ReturnType<typeof getSurveyCatalog>>, TError = ErrorType<unknown>>(
 params?: GetSurveyCatalogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyCatalogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSurveyIntakeStatus = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesIntakeStatusResponse>(
      {url: `/survey/intake-status`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyIntakeStatusQueryKey = () => {
    return [
    `/survey/intake-status`
    ] as const;
    }


export const getGetSurveyIntakeStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyIntakeStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyIntakeStatus>>> = ({ signal }) => getSurveyIntakeStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyIntakeStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyIntakeStatus>>>
export type GetSurveyIntakeStatusQueryError = ErrorType<unknown>


export function useGetSurveyIntakeStatus<TData = Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyIntakeStatus>>,
          TError,
          Awaited<ReturnType<typeof getSurveyIntakeStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyIntakeStatus<TData = Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyIntakeStatus>>,
          TError,
          Awaited<ReturnType<typeof getSurveyIntakeStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyIntakeStatus<TData = Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyIntakeStatus<TData = Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyIntakeStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyIntakeStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSurveyPending = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesPendingSurveysResponse>(
      {url: `/survey/pending`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyPendingQueryKey = () => {
    return [
    `/survey/pending`
    ] as const;
    }


export const getGetSurveyPendingQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyPending>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyPending>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyPendingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyPending>>> = ({ signal }) => getSurveyPending(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyPending>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyPendingQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyPending>>>
export type GetSurveyPendingQueryError = ErrorType<unknown>


export function useGetSurveyPending<TData = Awaited<ReturnType<typeof getSurveyPending>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyPending>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyPending>>,
          TError,
          Awaited<ReturnType<typeof getSurveyPending>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyPending<TData = Awaited<ReturnType<typeof getSurveyPending>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyPending>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyPending>>,
          TError,
          Awaited<ReturnType<typeof getSurveyPending>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyPending<TData = Awaited<ReturnType<typeof getSurveyPending>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyPending>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyPending<TData = Awaited<ReturnType<typeof getSurveyPending>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyPending>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyPendingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSurveyQuestionCatalog = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesTrainerQuestionListResponse>(
      {url: `/survey/question-catalog`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyQuestionCatalogQueryKey = () => {
    return [
    `/survey/question-catalog`
    ] as const;
    }


export const getGetSurveyQuestionCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyQuestionCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>> = ({ signal }) => getSurveyQuestionCatalog(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyQuestionCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>>
export type GetSurveyQuestionCatalogQueryError = ErrorType<unknown>


export function useGetSurveyQuestionCatalog<TData = Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyQuestionCatalog>>,
          TError,
          Awaited<ReturnType<typeof getSurveyQuestionCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyQuestionCatalog<TData = Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyQuestionCatalog>>,
          TError,
          Awaited<ReturnType<typeof getSurveyQuestionCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyQuestionCatalog<TData = Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyQuestionCatalog<TData = Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestionCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyQuestionCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postSurveyQuestionCatalog = (
    trainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesTrainerQuestionResponse>(
      {url: `/survey/question-catalog`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest, signal
    },
      options);
    }




export const getPostSurveyQuestionCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyQuestionCatalog>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyQuestionCatalog>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest>}, TContext> => {

const mutationKey = ['postSurveyQuestionCatalog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyQuestionCatalog>>, {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postSurveyQuestionCatalog(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyQuestionCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyQuestionCatalog>>>
    export type PostSurveyQuestionCatalogMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest> | undefined
    export type PostSurveyQuestionCatalogMutationError = ErrorType<unknown>

    export const usePostSurveyQuestionCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyQuestionCatalog>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyQuestionCatalog>>,
        TError,
        {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostTrainerQuestionRequest>},
        TContext
      > => {
      return useMutation(getPostSurveyQuestionCatalogMutationOptions(options), queryClient);
    }
    export const deleteSurveyQuestionCatalogId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/survey/question-catalog/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSurveyQuestionCatalogIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestionCatalogId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestionCatalogId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSurveyQuestionCatalogId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSurveyQuestionCatalogId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSurveyQuestionCatalogId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSurveyQuestionCatalogIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSurveyQuestionCatalogId>>>

    export type DeleteSurveyQuestionCatalogIdMutationError = ErrorType<unknown>

    export const useDeleteSurveyQuestionCatalogId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestionCatalogId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSurveyQuestionCatalogId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSurveyQuestionCatalogIdMutationOptions(options), queryClient);
    }
    export const patchSurveyQuestionCatalogId = (
    id: number,
    trainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesTrainerQuestionResponse>(
      {url: `/survey/question-catalog/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest, signal
    },
      options);
    }




export const getPatchSurveyQuestionCatalogIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyQuestionCatalogId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSurveyQuestionCatalogId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest>}, TContext> => {

const mutationKey = ['patchSurveyQuestionCatalogId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSurveyQuestionCatalogId>>, {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSurveyQuestionCatalogId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchSurveyQuestionCatalogIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchSurveyQuestionCatalogId>>>
    export type PatchSurveyQuestionCatalogIdMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest> | undefined
    export type PatchSurveyQuestionCatalogIdMutationError = ErrorType<unknown>

    export const usePatchSurveyQuestionCatalogId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyQuestionCatalogId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSurveyQuestionCatalogId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchTrainerQuestionRequest>},
        TContext
      > => {
      return useMutation(getPatchSurveyQuestionCatalogIdMutationOptions(options), queryClient);
    }
    export const getSurveyReviewQueue = (
    params?: GetSurveyReviewQueueParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyReviewQueueResponse>(
      {url: `/survey/review-queue`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSurveyReviewQueueQueryKey = (params?: GetSurveyReviewQueueParams,) => {
    return [
    `/survey/review-queue`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSurveyReviewQueueQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError = ErrorType<unknown>>(params?: GetSurveyReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyReviewQueueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyReviewQueue>>> = ({ signal }) => getSurveyReviewQueue(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyReviewQueueQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyReviewQueue>>>
export type GetSurveyReviewQueueQueryError = ErrorType<unknown>


export function useGetSurveyReviewQueue<TData = Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSurveyReviewQueueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyReviewQueue>>,
          TError,
          Awaited<ReturnType<typeof getSurveyReviewQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyReviewQueue<TData = Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError = ErrorType<unknown>>(
 params?: GetSurveyReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyReviewQueue>>,
          TError,
          Awaited<ReturnType<typeof getSurveyReviewQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyReviewQueue<TData = Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError = ErrorType<unknown>>(
 params?: GetSurveyReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyReviewQueue<TData = Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError = ErrorType<unknown>>(
 params?: GetSurveyReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyReviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyReviewQueueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSurveyTemplate = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyTemplateResponse>(
      {url: `/survey/template`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyTemplateQueryKey = () => {
    return [
    `/survey/template`
    ] as const;
    }


export const getGetSurveyTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyTemplate>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyTemplateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyTemplate>>> = ({ signal }) => getSurveyTemplate(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyTemplate>>>
export type GetSurveyTemplateQueryError = ErrorType<unknown>


export function useGetSurveyTemplate<TData = Awaited<ReturnType<typeof getSurveyTemplate>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplate>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplate<TData = Awaited<ReturnType<typeof getSurveyTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplate>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplate<TData = Awaited<ReturnType<typeof getSurveyTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyTemplate<TData = Awaited<ReturnType<typeof getSurveyTemplate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyTemplateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchSurveyTemplate = (
    trainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyTemplateResponse>(
      {url: `/survey/template`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest, signal
    },
      options);
    }




export const getPatchSurveyTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyTemplate>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSurveyTemplate>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest>}, TContext> => {

const mutationKey = ['patchSurveyTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSurveyTemplate>>, {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  patchSurveyTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchSurveyTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof patchSurveyTemplate>>>
    export type PatchSurveyTemplateMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest> | undefined
    export type PatchSurveyTemplateMutationError = ErrorType<unknown>

    export const usePatchSurveyTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyTemplate>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSurveyTemplate>>,
        TError,
        {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPatchSurveyTemplateRequest>},
        TContext
      > => {
      return useMutation(getPatchSurveyTemplateMutationOptions(options), queryClient);
    }
    export const postSurveyTemplate = (
    trainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyTemplateResponse>(
      {url: `/survey/template`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest, signal
    },
      options);
    }




export const getPostSurveyTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyTemplate>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyTemplate>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest>}, TContext> => {

const mutationKey = ['postSurveyTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyTemplate>>, {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postSurveyTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyTemplate>>>
    export type PostSurveyTemplateMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest> | undefined
    export type PostSurveyTemplateMutationError = ErrorType<unknown>

    export const usePostSurveyTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyTemplate>>, TError,{data?: BodyType<TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyTemplate>>,
        TError,
        {data?: BodyType<TrainWithMeModulesSurveysDtosRequestsCreateSurveyTemplateRequest>},
        TContext
      > => {
      return useMutation(getPostSurveyTemplateMutationOptions(options), queryClient);
    }
    export const getSurveyTemplateLatestSubmission = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse | void>(
      {url: `/survey/template/latest-submission`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyTemplateLatestSubmissionQueryKey = () => {
    return [
    `/survey/template/latest-submission`
    ] as const;
    }


export const getGetSurveyTemplateLatestSubmissionQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyTemplateLatestSubmissionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>> = ({ signal }) => getSurveyTemplateLatestSubmission(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyTemplateLatestSubmissionQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>>
export type GetSurveyTemplateLatestSubmissionQueryError = ErrorType<unknown>


export function useGetSurveyTemplateLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplateLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplateLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyTemplateLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateLatestSubmission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyTemplateLatestSubmissionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteSurveyTemplateId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/survey/template/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSurveyTemplateIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyTemplateId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyTemplateId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSurveyTemplateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSurveyTemplateId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSurveyTemplateId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSurveyTemplateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSurveyTemplateId>>>

    export type DeleteSurveyTemplateIdMutationError = ErrorType<unknown>

    export const useDeleteSurveyTemplateId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyTemplateId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSurveyTemplateId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSurveyTemplateIdMutationOptions(options), queryClient);
    }
    export const getSurveyTemplateId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyTemplateResponse>(
      {url: `/survey/template/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyTemplateIdQueryKey = (id: number,) => {
    return [
    `/survey/template/${id}`
    ] as const;
    }


export const getGetSurveyTemplateIdQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyTemplateId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyTemplateIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyTemplateId>>> = ({ signal }) => getSurveyTemplateId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyTemplateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyTemplateId>>>
export type GetSurveyTemplateIdQueryError = ErrorType<unknown>


export function useGetSurveyTemplateId<TData = Awaited<ReturnType<typeof getSurveyTemplateId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplateId<TData = Awaited<ReturnType<typeof getSurveyTemplateId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplateId>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplateId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplateId<TData = Awaited<ReturnType<typeof getSurveyTemplateId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyTemplateId<TData = Awaited<ReturnType<typeof getSurveyTemplateId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyTemplateIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchSurveyTemplateId = (
    id: number,
    trainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyTemplateResponse>(
      {url: `/survey/template/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest, signal
    },
      options);
    }




export const getPatchSurveyTemplateIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyTemplateId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSurveyTemplateId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest>}, TContext> => {

const mutationKey = ['patchSurveyTemplateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSurveyTemplateId>>, {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSurveyTemplateId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchSurveyTemplateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchSurveyTemplateId>>>
    export type PatchSurveyTemplateIdMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest> | undefined
    export type PatchSurveyTemplateIdMutationError = ErrorType<unknown>

    export const usePatchSurveyTemplateId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSurveyTemplateId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSurveyTemplateId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsUpdateSurveyTemplateRequest>},
        TContext
      > => {
      return useMutation(getPatchSurveyTemplateIdMutationOptions(options), queryClient);
    }
    export const postSurveyTemplateIdAssignments = (
    id: number,
    trainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesCheckInAssignmentResultResponse>(
      {url: `/survey/template/${id}/assignments`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest, signal
    },
      options);
    }




export const getPostSurveyTemplateIdAssignmentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyTemplateIdAssignments>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSurveyTemplateIdAssignments>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest>}, TContext> => {

const mutationKey = ['postSurveyTemplateIdAssignments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSurveyTemplateIdAssignments>>, {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  postSurveyTemplateIdAssignments(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostSurveyTemplateIdAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postSurveyTemplateIdAssignments>>>
    export type PostSurveyTemplateIdAssignmentsMutationBody = BodyType<TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest> | undefined
    export type PostSurveyTemplateIdAssignmentsMutationError = ErrorType<unknown>

    export const usePostSurveyTemplateIdAssignments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSurveyTemplateIdAssignments>>, TError,{id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSurveyTemplateIdAssignments>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesSurveysDtosRequestsPostCheckInAssignmentRequest>},
        TContext
      > => {
      return useMutation(getPostSurveyTemplateIdAssignmentsMutationOptions(options), queryClient);
    }
    export const deleteSurveyTemplateIdAssignmentsCustomerId = (
    id: number,
    customerId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesCheckInAssignmentResultResponse>(
      {url: `/survey/template/${id}/assignments/${customerId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteSurveyTemplateIdAssignmentsCustomerIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyTemplateIdAssignmentsCustomerId>>, TError,{id: number;customerId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyTemplateIdAssignmentsCustomerId>>, TError,{id: number;customerId: number}, TContext> => {

const mutationKey = ['deleteSurveyTemplateIdAssignmentsCustomerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSurveyTemplateIdAssignmentsCustomerId>>, {id: number;customerId: number}> = (props) => {
          const {id,customerId} = props ?? {};

          return  deleteSurveyTemplateIdAssignmentsCustomerId(id,customerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSurveyTemplateIdAssignmentsCustomerIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSurveyTemplateIdAssignmentsCustomerId>>>

    export type DeleteSurveyTemplateIdAssignmentsCustomerIdMutationError = ErrorType<unknown>

    export const useDeleteSurveyTemplateIdAssignmentsCustomerId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyTemplateIdAssignmentsCustomerId>>, TError,{id: number;customerId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSurveyTemplateIdAssignmentsCustomerId>>,
        TError,
        {id: number;customerId: number},
        TContext
      > => {
      return useMutation(getDeleteSurveyTemplateIdAssignmentsCustomerIdMutationOptions(options), queryClient);
    }
    export const getSurveyTemplateIdLatestSubmission = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyAssignmentResponse | void>(
      {url: `/survey/template/${id}/latest-submission`, method: 'GET', signal
    },
      options);
    }




export const getGetSurveyTemplateIdLatestSubmissionQueryKey = (id: number,) => {
    return [
    `/survey/template/${id}/latest-submission`
    ] as const;
    }


export const getGetSurveyTemplateIdLatestSubmissionQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyTemplateIdLatestSubmissionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>> = ({ signal }) => getSurveyTemplateIdLatestSubmission(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyTemplateIdLatestSubmissionQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>>
export type GetSurveyTemplateIdLatestSubmissionQueryError = ErrorType<unknown>


export function useGetSurveyTemplateIdLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplateIdLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplateIdLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyTemplateIdLatestSubmission<TData = Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplateIdLatestSubmission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyTemplateIdLatestSubmissionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSurveyTemplates = (
    params?: GetSurveyTemplatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesSurveysDtosResponsesSurveyTemplateListResponse>(
      {url: `/survey/templates`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetSurveyTemplatesQueryKey = (params?: GetSurveyTemplatesParams,) => {
    return [
    `/survey/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSurveyTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyTemplates>>, TError = ErrorType<unknown>>(params?: GetSurveyTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSurveyTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyTemplates>>> = ({ signal }) => getSurveyTemplates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSurveyTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyTemplates>>>
export type GetSurveyTemplatesQueryError = ErrorType<unknown>


export function useGetSurveyTemplates<TData = Awaited<ReturnType<typeof getSurveyTemplates>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSurveyTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplates>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplates<TData = Awaited<ReturnType<typeof getSurveyTemplates>>, TError = ErrorType<unknown>>(
 params?: GetSurveyTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSurveyTemplates>>,
          TError,
          Awaited<ReturnType<typeof getSurveyTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSurveyTemplates<TData = Awaited<ReturnType<typeof getSurveyTemplates>>, TError = ErrorType<unknown>>(
 params?: GetSurveyTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSurveyTemplates<TData = Awaited<ReturnType<typeof getSurveyTemplates>>, TError = ErrorType<unknown>>(
 params?: GetSurveyTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSurveyTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






